import { Send } from '@huspy/briks-icons';
import { Flex, Text } from '@huspy/briks-web';
import { BankSubmissionChannelType } from '@modules/opportunities/entities/bankApplication/bankApplication.entity';
import { BANK_SUBMISSION_CHANNEL_TYPE } from '@modules/opportunities/entities/bankApplication/const';
import React from 'react';
import { useTranslation } from 'react-i18next';

const baseTranslation = 'opportunity.caseSubmission.submitApplications.bankAndHuspySubmission.banksCard';

type Props = {
  bankSubmissionChannelType: BankSubmissionChannelType | null;
};

export const BankSubmissionStatusBadge = ({ bankSubmissionChannelType }: Props) => {
  const { t } = useTranslation();
  const submissionText = bankSubmissionChannelType === BANK_SUBMISSION_CHANNEL_TYPE.directBank
    ? t(`${baseTranslation}.sentThroughBank`)
    : t(`${baseTranslation}.sentThroughHuspy`);
  return (
    <Flex bg='indigo.50' borderRadius='10' py='2' px='4' align='center'>
      <Send color='#6366F1' />
      <Text ml='2' color='indigo.500' size='md' fontWeight='semibold'>
        {submissionText}
      </Text>
    </Flex>
  );
};
